"use strict";
import React from "react";
import { Separator } from "../Separator/Separator";
const OptionMenuSeparator = () => {
  return /* @__PURE__ */ React.createElement(Separator, { spacing: "xs", outset: "xs" });
};
export default OptionMenuSeparator;
